/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KursInfoVO { 
    id?: number;
    typ?: KursInfoVO.TypEnum;
    beschreibung?: string;
    datum?: string;
    von?: string;
    bis?: string;
    freiePlaetze?: number;
    online?: boolean;
    ort?: string;
    veranstaltungsort?: string;
}
export namespace KursInfoVO {
    export type TypEnum = 'ZERT_PENSION' | 'REZERT_PENSION' | 'ZERT_PFLEGEGELD' | 'REZERT_PFLEGEGELD' | 'ZERT_PFLEGEGELD_KINDER' | 'REZERT_PENSION_PSYCHIATRIE' | 'ZERT_GUTACHTUNG_AUVA';
    export const TypEnum = {
        ZERTPENSION: 'ZERT_PENSION' as TypEnum,
        REZERTPENSION: 'REZERT_PENSION' as TypEnum,
        ZERTPFLEGEGELD: 'ZERT_PFLEGEGELD' as TypEnum,
        REZERTPFLEGEGELD: 'REZERT_PFLEGEGELD' as TypEnum,
        ZERTPFLEGEGELDKINDER: 'ZERT_PFLEGEGELD_KINDER' as TypEnum,
        REZERTPENSIONPSYCHIATRIE: 'REZERT_PENSION_PSYCHIATRIE' as TypEnum,
        ZERTGUTACHTUNGAUVA: 'ZERT_GUTACHTUNG_AUVA' as TypEnum
    };
}


